import { FileKind } from "../../../../define/FileKind";
import { BaseLocalListData } from "../../base/BaseLocalListData";

/** 武将数据 */
class NewOfficerData{
    /** 武将唯一id */
    id: string = '';
    /** 战力 */
    battleForce: number = 0;
    /** 出兵速度 */
    dispatchSpeed: number = 0;
    /** 练兵速度 */
    outputSpeed: number = 0;
}

export default class MilitaryNewOfficerData extends BaseLocalListData {
    lists = new Map<string, NewOfficerData>();

    protected localKey: string = FileKind.SaveLocalDataKey.MILITARY_NEW_OFFICER_DATA;

    createItem(key: string): NewOfficerData {
        return this.createItemT<NewOfficerData>(NewOfficerData, key);
    }
}
